interface ZipCodeRange {
  start: number;
  end: number;
}

const bern1: ZipCodeRange = { start: 2500, end: 2762 };
const bern2: ZipCodeRange = { start: 3000, end: 3864 };
const solothurn: ZipCodeRange = { start: 1609, end: 1796 };
const fribourg1: ZipCodeRange = { start: 4226, end: 4252 };
const fribourg2: ZipCodeRange = { start: 4500, end: 4719 };

export const getBerneseSpokenZipCodeAreal = [bern1, bern2, solothurn, fribourg1, fribourg2];
